/// <amd-module name="VSSUI/Components/StackPanel/StackPanelContext" />
import * as React from "react";
import { IStackPanelProviderContext } from "./StackPanel.Props";

export const StackPanelProviderContext = React.createContext<IStackPanelProviderContext>({
    push: () => {},
    pop: () => {
        return undefined;
    },
    peek: () => {
        return undefined;
    }
});

export class StackPanelProvider extends React.Component<IStackPanelProviderContext> {
    public render() {
        return <StackPanelProviderContext.Provider value={this.props}>{this.props.children}</StackPanelProviderContext.Provider>;
    }
}
